<template>
  <form :key="fwInstanceKey">
    <template v-for="component in schema.components">
      <component
        :is="component.type"
        :key="component.key"
        :theme="theme"
        :ctx-a="component"
        :store="store"
      ></component>
    </template>
    <!-- For rendering the fine uploader -->
    <fine-uploader-template />
  </form>
</template>

<script>
import Vue from 'vue';
import '../assets/icons.css';
import '../formComponents';
import cloneDeep from 'lodash.clonedeep';
import store from '../store/store';
import fineUploaderTemplate from '../formComponents/file/fineUploaderTemplate.vue';
import { getInputComponents, getRandomString } from '../utils';

export default {
  name: 'formways',
  components: {
    fineUploaderTemplate
  },
  props: {
    schema: {
      type: Object,
      default: () => ({ components: [] })
    },
    theme: {
      type: String,
      default: 'bootstrap4'
    },
    value: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      store: cloneDeep(store),
      fwInstanceKey: 1 // This is used to rerender the formways instance manually
    };
  },
  created() {
    /**
     * This intance is used for inter-component communication witout any restrictions
     * Used to implement publish/subscribe pattern in the components
     * getRandomString does not do anything. Its just to identify the formways object in case of
     * multiple fw instanes on a page
     */
    this.store.eventBus = new Vue({
      name: `FwEventBus-${getRandomString(10)}`
    });
    this._copyDataAndContextToStore();
  },
  mounted() {
    this.store.eventBus.$on('form.submit', this.submit);
    this.store.eventBus.$on('value-changed', this.valueChanged);
    // Custom event from button components
    this.store.eventBus.$on('button.custom-event', this.customEvent);
  },
  methods: {
    _copyDataAndContextToStore() {
      // To set the values to the store
      Object.keys(this.value).forEach(key => {
        this.store.setFormFieldValue(key, this.value[key]);
      });
      // set context to store
      Object.keys(this.context).forEach(key => {
        this.store.setContextValue(key, this.context[key]);
      });
    },
    /**
     * Emulating the reset button action
     * Every field components will be listening to this event.
     */
    reset() {
      this.store.eventBus.$emit('form.reset');
      
      // this.clearAllData();
      // setTimeout(() => {
      //   this.reRender();
      // }, 10);
    },
    /**
     * Broadcast a validate request to all components.
     * validate() function in every field component will be trigged.
     */
    validate() {
      this.store.eventBus.$emit('from.validate');
    },
    /**
     * emits on-submit event when form submit event is triggered from a button
     * This event could be listened from outside the formways
     */
    submit() {
      this.$emit('on-submit', this.value);
    },
    /**
     * to modify the v-model when the form value changes
     */
    valueChanged() {
      this.$emit('input', this.store.state.formValues);
    },
    /**
     * To emit custom event to outside of formways
     * when a button is clicked
     */
    customEvent(eventName) {
      this.$emit(eventName);
    },
    /**
     * Clear AMS fields present in the form
     */
    clearAmsFields() {
      // const allInputComponents = getInputComponents(this.schema);
      const self = this;
      const amsFields = getInputComponents(this.schema, true);
      amsFields.forEach(field => {
        self.value[field.key] = '';
      });
    },
    /**
     * Clears  all data in the form.
     * Unlike `reset` this method will not populate the default value after clearing.
     */
    clearAllData() {
      Object.keys(this.value).forEach(key => {
        if(typeof this.value[key] === "object") {
          Vue.set(this.value,key,[]);
        } else {
          Vue.set(this.value,key,'');
        }
      });
    },
    /**
     * To forced rerender the form.
     * This is required when the context data changes and the form element depends on context
     */
    reRender() {
      this._copyDataAndContextToStore();
      setTimeout(() => {
        this.fwInstanceKey = this.fwInstanceKey + 1;
      }, 0);
    }
  }
};
</script>
